module.exports = __webpack_public_path__ + "img/thumbnail_SpottedHyena_f_normal.08bb489d.png";